const styles = (theme) => ({
  subheader: {
    color: theme.color.grey_8A,
    fontSize: 16,
    lineHeight: '20px',
    padding: theme.spacing(1, 2.5),
  },

  pageLayout: {
    marginBottom: theme.spacing(0.5),
  },

  confirmation: {
    backgroundColor: theme.color.white,
    bottom: 0,
    display: 'block',
    left: 0,
    padding: theme.spacing(2.5),
    position: 'absolute',
    width: '100%',
  },
});

export default styles;
